export default {
  questionnaireList: [],
  pager: false,
  questionnaireData: {},
  // 是否进入问卷预览模式
  preview: "",
  // 底色配置项
  colorOption: {},
  rules: [
    { label: '不限', value: 'ignore' },
    { label: '数字', value: 'number' },
    { label: '字母', value: 'en' },
    { label: '中文', value: 'ch' },
    { label: 'Email', value: 'email' },
    { label: '手机号码', value: 'phone' }
  ],
  columnSetting:
  [
    {
      text: '单列',
      value: '1',
    },
    {
      text: '双列',
      value: '2',
    },
    {
      text: '三列',
      value: '3',
    },
  ],
  // 是否查看详情
  isViewDetails: false
}
